export class NineSimplePopup extends HTMLElement {
	static get tagName() { return "nine-simple-popup"; }

	constructor() {
		super();
	}

	connectedCallback() {
		const titleText = this.getAttribute("subject") || "Details";

		this.innerHTML = `
			<style>
				nine-simple-popup {
					position: fixed;
					top: 0;
					left: 0;
					width: 100vw;
					height: 100vh;
					z-index: 9999;
					font-family: inherit;
				}
				nine-simple-popup .ns-popup-overlay {
					width: 100%;
					height: 100%;
					background-color: rgba(0, 0, 0, 0.4);
					display: flex;
					justify-content: center;
					align-items: center;
					backdrop-filter: blur(2px);
				}
				nine-simple-popup .ns-popup-dialog {
					background-color: #ffffff;
					--width: 460px;
					border-radius: 12px;
					box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
					display: flex;
					flex-direction: column;
					overflow: hidden;
					animation: nsPopupShow 0.2s ease-out;
				}
				nine-simple-popup .ns-popup-header {
					padding: 16px 20px;
					display: flex;
					justify-content: space-between;
					align-items: center;
					border-bottom: 1px solid #f1f5f9;
				}
				nine-simple-popup .ns-popup-title {
					font-size: 16px;
					font-weight: 700;
					color: #0f172a;
				}
				nine-simple-popup .ns-popup-close-btn {
					background: none;
					border: none;
					font-size: 20px;
					color: #94a3b8;
					cursor: pointer;
					padding: 0;
					line-height: 1;
				}
				nine-simple-popup .ns-popup-close-btn:hover {
					color: #0f172a;
				}
				nine-simple-popup .ns-popup-body {
					padding: 20px;
					max-height: 80vh;
					overflow-y: auto;
				}
				@keyframes nsPopupShow {
					from {
						opacity: 0;
						transform: scale(0.95) translateY(10px);
					}
					to {
						opacity: 1;
						transform: scale(1) translateY(0);
					}
				}
			</style>
			
			<div class="ns-popup-overlay">
				<div class="ns-popup-dialog">
					<div class="ns-popup-header">
						<span class="ns-popup-title">${titleText}</span>
						<button class="ns-popup-close-btn">&times;</button>
					</div>
					<div class="ns-popup-body"></div>
				</div>
			</div>
		`;

		this.querySelector('.ns-popup-close-btn').onclick = () => this.close(null);
		this.querySelector('.ns-popup-overlay').onclick = (e) => {
			if (e.target.classList.contains('ns-popup-overlay')) {
				this.close(null);
			}
		};
	}

	close(returnValue = null) {
		this.dispatchEvent(new CustomEvent('closed', { detail: returnValue }));
		this.remove();
	}

	get popupBody() {
		return this.querySelector('.ns-popup-body') || null;
	}
}

if (!customElements.get('nine-simple-popup')) {
	customElements.define('nine-simple-popup', NineSimplePopup);
}